import QRCode from "react-qr-code";
import { useState} from "react";
import "./style.css"
import Vehicle from "../../../components/vehicle"
import pathIcon from "../../../icons/path.svg"
import infoIcon from "../../../icons/info.svg"
import Moment from "react-moment";
import 'react-slideshow-image/dist/styles.css'
import clockIcon from "../../../icons/clock.svg"
import arrowRightIcon from "../../../icons/arrow-right.svg"
import {useNavigate} from "react-router-dom";
import closeIcon from "../../../icons/close.svg";
import checkColorIcon from "../../../icons/check-color.svg";

const Details = ({order, close}) => {
    const [showMessage, setShowMessage] = useState(false)
    const copyUrl = (url) => {
        return () => {
            window.navigator.clipboard.writeText(url);
            setShowMessage(true)
            setTimeout(() => {
                setShowMessage(false)
            }, 3000)
        }
    }

    return <div>
        <div style={{background: "#0000004D", position: "fixed", top: 0, left: 0, right: 0, bottom: 0}}></div>
        {showMessage && <div style={{
            position: "fixed",
            zIndex: 19999,
            top: 20,
            width: "calc(100% - 32px)",
            height: 46,
            lineHeight: "46px",
            fontSize: 16,
            borderRadius: 16,
            background: "white",
            textAlign: "center",
            letterSpacing: -0.3,
            display: "flex",
            color: "#141414",
            left: 16,
        }}>
            <div style={{
                width: "100%",
                textAlign: "left",
                paddingLeft: 16
            }}>Ссылка скопирована
            </div>
            <div style={{
                paddingRight: 16,
                paddingTop: 12
            }}>
                <img alt={""} src={checkColorIcon} style={{width: 24, height: 24, display: "block"}}/>
            </div>
        </div>}
        <div style={{
            background: "white",
            position: "fixed",
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            left: 0,
            right: 0,
            bottom: 0,
            height: 592,
            zIndex: 9999,
            padding: 16
        }}>
            <div style={{display: "flex"}}>
                <div style={{
                    lineHeight: "44px",
                    color: "#141414",
                    fontWeight: 500,
                    fontSize: 19,
                    letterSpacing: -0.03
                }}>Детали
                </div>
                <div>
                    <button onClick={() => close()}
                            style={{
                                position: "absolute",
                                right: 16,
                                top: 16,
                                padding: 8,
                                border: 0,
                                background: "#F1F1F1",
                                borderRadius: 8
                            }}>
                        <img src={closeIcon} style={{display: "block"}}/>
                    </button>
                </div>
            </div>
            <div style={{marginTop: 8, paddingBottom: 18}}>
                <div className={"order-detail-name"}>Общая сумма</div>
                <div className={"order-detail-value"}>{order.price / 100} ₽</div>

                {order.count !== 1 && <><div className={"order-detail-name"}>Количество</div>
                <div className={"order-detail-value"}>{order.count}</div></>}

                <div className={"order-detail-name"}>Номер транзакции</div>
                <div className={"order-detail-value"}>{order.id.slice(-8)}</div>

                <div className={"order-detail-name"}>Номера оплаты</div>
                <div className={"order-detail-value"}>{order.tickets.map((ticket) => <span
                    style={{marginRight: 8}}>{ticket.id.slice(-8)}</span>)}</div>

                <div className={"order-detail-name"}>Организация</div>
                <div className={"order-detail-value"}>{order.organization?.name}</div>

                {order.attributes?.receipts && order.attributes?.receipts.length > 0 &&
                    order.attributes?.receipts.map((receipt, i)=> <div onClick={copyUrl(receipt)} style={{
                        textAlign: "center",
                        background: "#1414140F",
                        lineHeight: "48px",
                        borderRadius: 8,
                        fontSize: 15,
                        fontWeight: 600,
                        letterSpacing: -0.15,
                        border: 0,
                        width: "100%",
                        color: "#1BA136",
                        marginBottom: 12,
                    }}>
                        { order.attributes?.receipts.length === 1 ? "Чек" : "Чек для билета №" + (i+1)}
                    </div>)
                }
            </div>
        </div>
    </div>
}

const Order = ({ order }) => {
    const [showDetails, setShowDetails] = useState(false)
    const navigate = useNavigate()

    return <div style={{paddingBottom: 64}}>
        <div className={"order-wrapper"}>
            <div style={{
                display: "flex", justifyContent: "space-between",
                color: "#898989",
                fontSize: 14,
                marginLeft: 16,
                marginRight: 16,
                marginBottom: 8,
                fontWeight: 600,
                letterSpacing: -0.15
            }}>
                <div><Moment format={"DD MMMM · HH:mm"}>{order.created_at}</Moment> · {order.price / 100} &#x20bd;</div>
            </div>
            <div className={"order"}>
                <div>
                    <div style={{marginBottom:8}}>
                        {order.object.name}
                    </div>
                    <div>
                        <small>{order.object.description}</small>
                    </div>
                </div>
                <div style={{display: "flex", marginTop: 12, gap: 12}} onClick={() => setShowDetails(true)}>
                    <div><img style={{display: "block"}} src={infoIcon}/></div>
                    <div
                        style={{lineHeight: "26px", width: "100%"}}>Детали оплаты
                    </div>
                    <div><img src={arrowRightIcon}/></div>
                </div>
                {showDetails && <Details order={order} close={() => setShowDetails(false)}/>}
            </div>
            {order.tickets?.map((ticket, index) => <div style={{marginTop: 12}}>
                <div style={{
                    display: "flex", justifyContent: "space-between",
                    color: "#898989",
                    fontSize: 14,
                    marginLeft: 16,
                    marginRight: 16,
                    marginBottom: 12,
                    fontWeight: 600,
                    letterSpacing: -0.15
                }}>
                    <div>Оплата №{index + 1} · {ticket.price / 100}&nbsp;&#x20bd;</div>
                </div>
                <div className={"order"} style={{background: "white", colorScheme: "light only"}}><QRCode
                    fgColor={"#0B3045"} bgColor={"white"} style={{
                    filter: "none",
                    forcedColorAdjust: "none",
                    colorScheme: "light only",
                    display: "block",
                    width: "100%"
                }}
                    size={"100%"}
                    value={ticket.digest}/></div>
            </div>)}
        </div>
    </div>
}


export default Order;